import React, { useState, useEffect } from 'react';
import { Info } from 'lucide-react';
import { getRedditBuzz } from '../../services/api';
import './RedditBuzz.css';

const formatNum = (n) => n != null ? n.toLocaleString('en-US') : '-';

const RedditBuzz = ({ ticker }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!ticker) return;
    let cancelled = false;
    getRedditBuzz(ticker).then(result => {
      if (!cancelled) setData(result);
    });
    return () => { cancelled = true; };
  }, [ticker]);

  if (!ticker || !data) return null;

  const { rank, rankChange, mentions, mentionChangePct, upvotes } = data;

  const rankColor = rankChange > 0 ? '#16a34a' : rankChange < 0 ? '#dc2626' : '#9ca3af';
  const mentionColor = mentionChangePct > 0 ? '#16a34a' : mentionChangePct < 0 ? '#dc2626' : '#9ca3af';
  const rankArrow = rankChange > 0 ? '▲' : rankChange < 0 ? '▼' : '';
  const mentionArrow = mentionChangePct > 0 ? '▲' : mentionChangePct < 0 ? '▼' : '';

  return (
    <div className="reddit-compact-box">
      <div className="reddit-compact-header">
        <i className="fa-brands fa-reddit-alien reddit-compact-icon" />
        <div className="reddit-compact-label-wrap">
          <div className="flex items-center gap-2">
            <span className="reddit-compact-label">Reddit 버즈</span>
            <span className="edu-fun-badge">스낵 콘텐츠</span>
          </div>
          <span className="reddit-compact-desc">r/stocks · r/wallstreetbets · 24시간 내 언급량 기준</span>
        </div>
      </div>

      <div className="reddit-compact-stats">
        <div className="reddit-compact-stat">
          <span className="reddit-compact-stat-name">랭킹</span>
          <span className="reddit-compact-stat-val">
            #{rank}
            {rankChange !== 0 && (
              <span style={{ color: rankColor, fontSize: 11, marginLeft: 3 }}>
                {rankArrow}{Math.abs(rankChange)}
              </span>
            )}
          </span>
        </div>

        <div className="reddit-compact-divider" />

        <div className="reddit-compact-stat">
          <span className="reddit-compact-stat-name">
            언급수
            <button className="relative" onMouseEnter={() => setShowTooltip('mentions')} onMouseLeave={() => setShowTooltip(false)}>
              <Info size={9} className="text-gray-300 hover:text-gray-500" />
              {showTooltip === 'mentions' && (
                <div className="metric-tooltip">
                  <div className="metric-tooltip-desc">Reddit 게시글·댓글에서 해당 종목이 언급된 횟수. 많을수록 커뮤니티에서 활발히 논의 중입니다.</div>
                </div>
              )}
            </button>
          </span>
          <span className="reddit-compact-stat-val">
            {formatNum(mentions)}
            {mentionChangePct != null && (
              <span style={{ color: mentionColor, fontSize: 11, marginLeft: 3 }}>
                {mentionArrow}{Math.abs(mentionChangePct).toFixed(0)}%
              </span>
            )}
          </span>
        </div>

        <div className="reddit-compact-divider" />

        <div className="reddit-compact-stat">
          <span className="reddit-compact-stat-name">
            관심도
            <button className="relative" onMouseEnter={() => setShowTooltip('upvotes')} onMouseLeave={() => setShowTooltip(false)}>
              <Info size={9} className="text-gray-300 hover:text-gray-500" />
              {showTooltip === 'upvotes' && (
                <div className="metric-tooltip">
                  <div className="metric-tooltip-desc">Reddit 게시글의 추천 수 합산. 높을수록 해당 종목에 대한 커뮤니티 관심이 높습니다.</div>
                </div>
              )}
            </button>
          </span>
          <span className="reddit-compact-stat-val">{formatNum(upvotes)}</span>
        </div>
      </div>

      <p className="reddit-compact-footer">* r/stocks · r/wallstreetbets 기준</p>
    </div>
  );
};

export default RedditBuzz;
